import { render } from "./VerifiedIcon.vue?vue&type=template&id=e5c58e18"
import script from "./VerifiedIcon.vue?vue&type=script&lang=js"
export * from "./VerifiedIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__